import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { register as registerSwiperElements } from 'swiper/element/bundle';
import { initPostHog } from '@handshake/core-fe';
import { environment } from '@environments/environment';

// Register Swiper custom elements. We do this
// before bootstrapping the Angular application
// so that they're available before any part of
// our application tries rendering them.
registerSwiperElements();

initPostHog(environment.posthog);

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    const initialLoading = document.getElementById("initial-loading");
    if (initialLoading) {
      initialLoading.hidden = true;
    }
  })
  .catch((err) => console.error(err));
